















export default {
	name: 'Update',
	data() {
		return {
			logo: this.$store.state.ramboxLogo,
		};
	},
	async mounted() {
		try {
			// @ts-ignore-next-line
			await window.FreshworksWidget('destroy');
		} catch (error) {}
	},
};
